/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seat_Price_Scheduled_Cancel_HintInputs */



/**
* | output |
* | --- |
* | "You can undo this change any time before then." |
*
* @param {Seat_Price_Scheduled_Cancel_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_price_scheduled_cancel_hint = /** @type {((inputs?: Seat_Price_Scheduled_Cancel_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Price_Scheduled_Cancel_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie können diese Änderung bis dahin jederzeit zurücknehmen.")
	return /** @type {LocalizedString} */ ("You can undo this change any time before then.")
});